const Images = {
  logo: require("./logo.png"),
  appStoreBtn: require("./appstore_button.png"),
  playStoreBtn: require("./playstore_button.png"),
  bannerBackground: require("./30934848_7759693[1].png"),
  banner: require("./FANOOS_0Banner.png")
}

export default Images;